import { render, staticRenderFns } from "./GifterPairs.vue?vue&type=template&id=50fcc69b&"
import script from "./GifterPairs.vue?vue&type=script&lang=js&"
export * from "./GifterPairs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports